<template>

<div class="panel-heading">
  <slot name="top"></slot>
  <slot name="title">{{title}}</slot>
  <span v-if="subtitle" class="panel-subtitle">{{subtitle}}</span>
  <slot></slot>
</div>

</div>

</template>

<script>

export default {
  props: ['title', 'subtitle'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// Heading.vue?671ed799